import { NavItemsSimple } from '@/components/custom/nav-Items-simple'
import { useProjectStore } from '@/core/project/store/project.store'
import { useCharactersStore } from '@/features/shared/stores/characters.store'
import { useSceneStore } from '@/features/shared/stores/scene.store'
import WorkspaceSidebarScaffold from '@/features/workspace/components/WorkspaceSidebarScaffold'
import { Sidebar } from '@/shared/components/ui/sidebar'
import { SerializedContent } from '@storyverse/shared'
import { Download } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { useCharacters, useSaveCharacterMutation } from '../queries/character.queries'
import { characterService } from '../service/character.service'

export function ChSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { project } = useProjectStore()
    const { editor } = useSceneStore()
    const { characters } = useCharactersStore()
    const { isLoading } = useCharacters(project?.id || '')
    const saveCharacter = useSaveCharacterMutation()

    const handleImportFromScreenplay = async () => {
        if (!editor || !project) {
            toast.error("Screenplay editor not ready")
            return
        }

        try {
            const content = (editor.getEditorState().toJSON().root.children as unknown) as SerializedContent[]
            const extracted = characterService.extractCharactersFromScreenplay(content, project.id)

            if (extracted.length === 0) {
                toast.info("No characters found in screenplay")
                return
            }

            // Filter out characters already in the list
            const existingNames = new Set(characters.map(c => (c.fullname || '').toUpperCase()))
            const newCharacters = extracted.filter(c => c.fullname && !existingNames.has(c.fullname.toUpperCase()))

            if (newCharacters.length === 0) {
                toast.info("All characters from screenplay are already in the list")
                return
            }

            for (const char of newCharacters) {
                await saveCharacter.mutateAsync(char)
            }

            toast.success(`Imported ${newCharacters.length} new characters`)
        } catch (error) {
            console.error("Import error:", error)
            toast.error("Failed to import characters")
        }
    }

    const navItems = [
        {
            name: "Import from Screenplay",
            emoji: <Download className="w-4 h-4" />,
            onClick: handleImportFromScreenplay
        }
    ]

    return (
        <WorkspaceSidebarScaffold {...props}>
            <NavItemsSimple
                navItems={navItems}
                header={{ title: 'Character Actions' }}
            />

        </WorkspaceSidebarScaffold>
    )
}

export default ChSidebar
